export const Environment = {
  BACKEND_API: process.env.REACT_APP_BACKEND_API || '',
  AUTH0_DOMAIN: process.env.REACT_APP_AUTH0_DOMAIN || '',
  AUTH0_CLIENT: process.env.REACT_APP_AUTH0_CLIENT || '',
  AUTH0_AUDIENCE: process.env.REACT_APP_AUTH0_AUDIENCE || '',
  AUTH0_API: `https://${process.env.REACT_APP_AUTH0_DOMAIN}`,
  POSTHOG_HOST: process.env.REACT_APP_POSTHOG_HOST || '',
  POSTHOG_TOKEN: process.env.REACT_APP_POSTHOG_TOKEN || '',
  POSTHOG_ENABLED: process.env.REACT_APP_POSTHOG_ENABLED || 'false',
  DD_LOGS_ENABLED: process.env.REACT_APP_DD_LOGS_ENABLED || 'false',
  DD_LOGS_CLIENT_TOKEN: process.env.REACT_APP_DD_LOGS_CLIENT_TOKEN || '',
  DD_SERVICE: process.env.REACT_APP_DD_SERVICE || '',
  DD_ENV: process.env.REACT_APP_DD_ENV || '',
  COOKIE_BOT_ID: process.env.REACT_APP_COOKIE_BOT_ID || '',
  IDME_ENABLED: process.env.REACT_APP_IDME_ENABLED || 'false',
  IDME_AUTHORIZATION_ENDPOINT:
    process.env.REACT_APP_IDME_AUTHORIZATION_ENDPOINT,
  IDME_CLIENT_ID: process.env.REACT_APP_IDME_CLIENT_ID,
  IDME_REDIRECT_URI: process.env.REACT_APP_IDME_REDIRECT_URI,
  IDME_RESPONSE_TYPE: process.env.REACT_APP_IDME_RESPONSE_TYPE,
  IDME_SCOPE: process.env.REACT_APP_IDME_SCOPE,
  AUTH0_SSO_ENABLED: process.env.REACT_APP_AUTH0_SSO_ENABLED || 'false',
  AUTH0_SSO_CLIENT_ID: process.env.REACT_APP_AUTH0_SSO_CLIENT_ID,
  AUTH0_SSO_REDIRECT_URI: process.env.REACT_APP_AUTH0_SSO_REDIRECT_URI,
  AUTH0_SSO_AUTHORIZATION_ENDPOINT:
    process.env.REACT_APP_AUTH0_SSO_AUTHORIZATION_ENDPOINT,
  AUTH0_SSO_RESPONSE_TYPE: process.env.REACT_APP_AUTH0_SSO_RESPONSE_TYPE,
  AUTH0_SSO_SCOPE: process.env.REACT_APP_AUTH0_SSO_SCOPE,
  FEATURE_MANUAL_REFERRAL_ENABLED:
    process.env.REACT_APP_FEATURE_MANUAL_REFERRAL_ENABLED || 'false',
};
